import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { routerNavigatedAction } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { navigate, navigateBackward, navigateForward } from './router.actions';

@Injectable()
export class RouterEffects {
    navigate$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(navigate),
                map((action) => {
                    this.router.navigate(action?.url, { ...action.extras, queryParamsHandling: 'merge', queryParams: action?.queryParams });
                })
            );
        },
        { dispatch: false }
    );

    forward$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(navigateForward),
                map((action) => {
                    this.location.forward();
                })
            );
        },
        { dispatch: false }
    );
    backward$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(navigateBackward),
                map((action) => {
                    this.location.back();
                })
            );
        },
        { dispatch: false }
    );

    saveLocation$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(routerNavigatedAction),
                map((action) => {
                    localStorage.setItem('lastLocation', action.payload.routerState.url);
                })
            );
        },
        { dispatch: false }
    );

    constructor(private actions$: Actions, private router: Router, private location: Location, private store: Store<any>) {}
}
